'use strict';

import React from 'react';
import {Link, browserHistory } from 'react-router';
import LazyLoad from 'react-lazy-load';

import 'styles/MediaList.scss';

class MediaComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      medias: props.medias,
      loading: props.loading
    };
    this.gotoPublish = this.gotoPublish.bind(this);
  }
  gotoPublish(event){
    browserHistory.push('/publish');
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      medias: nextProps.medias,
      loading: nextProps.loading
    });
  }
  render() {
    let mediaList;
    if(this.state.medias.length === 0 && !this.state.loading) {
      mediaList = (
        <p onClick={this.gotoPublish} className="text-gray text-center mt-50 fz-16">占领这个地方～～</p>
      );
    } else {
      mediaList = this.state.medias.map((media) => {
          if(media&&!media.deleted){
            return (
              <Link to={`/media/${media._id}`} key={media._id}>
                <div className="media small-12 columns" key={media._id}>
                  <div className="wapper">
                    <LazyLoad throttle={50} debounce={true} >
                      <img src={media.images.big.length?media.images.big[0]:''} className="float-center" />
                    </LazyLoad>
                  </div>
                  <blockquote>
                    <p className="mb-0 text-black media-desc">{media.desc}</p>
                    <cite>{media.author ? media.author.name : ''}</cite>
                  </blockquote>
                </div>
              </Link>
            );
          }
        }
      );
    }
    return (
      <div className="media-component expanded row">
        {mediaList}
      </div>
    );
  }
}

MediaComponent.displayName = 'MediaComponent';
export default MediaComponent;



// WEBPACK FOOTER //
// ./src/components/MediaListComponent.js